var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeSquareLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_5101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8109 0H92.227V5.41621H86.8109V0ZM144.584 0.00085867H150V5.41707H144.584V0.00085867ZM34.4543 0H29.0382V5.41621H34.4543V0ZM115.697 0H121.114V5.41621H115.697V0ZM63.3407 0H57.9245V5.41621H63.3407V0ZM0.151978 0H5.56739V5.41621H0.151978V0ZM150 57.7727H144.584V63.1889H150V57.7727ZM86.8109 57.7727H92.227V63.1889H86.8109V57.7727ZM34.4543 57.7727H29.0382V63.1889H34.4543V57.7727ZM115.697 57.7727H121.114V63.1889H115.697V57.7727ZM63.3407 57.7727H57.9245V63.1889H63.3407V57.7727ZM0.151978 57.7727H5.56739V63.1889H0.151978V57.7727ZM150 115.545H144.584V120.962H150V115.545ZM86.8109 115.545H92.227V120.962H86.8109V115.545ZM34.4543 115.545H29.0382V120.962H34.4543V115.545ZM115.697 115.545H121.114V120.962H115.697V115.545ZM63.3407 115.545H57.9245V120.962H63.3407V115.545ZM0.151978 115.545H5.56739V120.962H0.151978V115.545ZM150 28.8867H144.584V34.3029H150V28.8867ZM86.8109 28.8867H92.227V34.3029H86.8109V28.8867ZM34.4543 28.8867H29.0382V34.3029H34.4543V28.8867ZM115.697 28.8867H121.114V34.3029H115.697V28.8867ZM63.3407 28.8867H57.9245V34.3029H63.3407V28.8867ZM0.151978 28.8867H5.56739V34.3029H0.151978V28.8867ZM150 86.6594H144.584V92.0756H150V86.6594ZM86.8109 86.6594H92.227V92.0756H86.8109V86.6594ZM34.4543 86.6594H29.0382V92.0756H34.4543V86.6594ZM115.697 86.6594H121.114V92.0756H115.697V86.6594ZM63.3407 86.6594H57.9245V92.0756H63.3407V86.6594ZM0.151978 86.6594H5.56739V92.0756H0.151978V86.6594ZM150 144.432H144.584V149.849H150V144.432ZM86.8109 144.432H92.227V149.849H86.8109V144.432ZM34.4543 144.432H29.0382V149.849H34.4543V144.432ZM115.697 144.432H121.114V149.849H115.697V144.432ZM63.3407 144.432H57.9245V149.849H63.3407V144.432ZM0.151978 144.432H5.56739V149.849H0.151978V144.432Z",
    fill: "url(#paint0_linear_119_5101)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_5101",
    x1: -3.65549,
    y1: 10.0592,
    x2: 152.492,
    y2: 23.1207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47CCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CCDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_5101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "matrix(-1 0 0 1 150 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSquareLinear);
export default __webpack_public_path__ + "static/media/shape-square-linear.80ed329734d33f88e9e9caa3c16d8cb7.svg";
export { ForwardRef as ReactComponent };